import baseCreate from './_baseCreate';
import getPrototype from './_getPrototype';
import isPrototype from './_isPrototype';

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

export default initCloneObject;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_initCloneObject.js
// module id = 344
// module chunks = 0